import css from './navigationItem.module.css'
import { memo, ReactNode, useMemo, useRef } from 'react'
import ArrowRight from '../../../../../assets/icons/arrowRight.svg?react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import usePopup from '../../../../hooks/usePopup.ts'
import FadeInPanel from '@/shared/Animated/FadeInPanel'

interface IProps {
  icon: ReactNode
  title: string
  navItems: Array<{ title: string; to: string }>
  minified: boolean

  // В случае, если текущий роут содержит один из указанных префиксов, иконка будет посдвечена в active стейт
  matchPrefixes: string[]
}

const NavigationItem = (props: IProps) => {
  const location = useLocation()
  const navigate = useNavigate()

  const ref = useRef<HTMLDivElement>(null)
  const { open, setOpen } = usePopup(ref)

  const isPathMatching = useMemo(() => {
    if (!props.matchPrefixes) return false

    if (props.matchPrefixes.length === 0 && props.navItems.length === 1) {
      return props.navItems[0].to === location.pathname
    }

    return props.matchPrefixes.some((p) => location.pathname.startsWith(p))
  }, [location.pathname, props.matchPrefixes])

  const menuContent = props.navItems.map((it) => (
    <Link key={it.to} to={it.to} className={css.navOption}>
      <span className="text-nm">{it.title}</span>
    </Link>
  ))

  const handleClick = () => {
    if (props.navItems.length > 1) {
      setOpen((prev) => !prev)
    } else if (props.navItems.length === 1) {
      navigate(props.navItems[0].to)
    }
  }

  if (props.minified) {
    return (
      <div className={css.wrapperMin} onClick={handleClick} data-open={open} data-active={isPathMatching} ref={ref}>
        {props.icon}
        {props.navItems.length > 1 && (
          <FadeInPanel className={css.navMenu} open={open}>
            {menuContent}
          </FadeInPanel>
        )}
      </div>
    )
  }

  return (
    <div className={css.wrapper} data-open={open} data-active={isPathMatching} ref={ref} onClick={handleClick}>
      <div className="inline-flex-gap gap24 center">
        {props.icon}
        <p className="text-nm line-clamp" style={{ color: 'inherit' }}>
          {props.title}
        </p>
      </div>
      {props.navItems.length > 1 && <ArrowRight style={{ width: '16px', height: '16px' }} />}
      <FadeInPanel open={open} className={css.navMenu}>
        {menuContent}
      </FadeInPanel>
    </div>
  )
}

export default memo(NavigationItem)
